// Cookie 讀寫工具：統一透過 js-cookie 操作，全專案僅此檔 import js-cookie。
import JsCookie from 'js-cookie';

// 停用 js-cookie 預設的 URI 編碼，保留與原本 document.cookie 相同的原始 cookie 值：
// JWT 與 xsrf-token 皆為安全字元，且 xsrf-token 採 double-submit（cookie 值需與送出的
// header 值逐字相符），若被編碼會造成後端比對失敗。
const Cookies = JsCookie.withConverter({
  read: (value) => value,
  write: (value) => value,
});

// 正式 / 測試環境下 cookie 需跨 hexschool 子網域共用；本機環境不設 domain，讓 cookie 落在當前 host。
const isCrossSiteEnv = () => ['production', 'development'].includes(process.env.VUE_APP_ENV);
const crossSiteOptions = (enabled) => (enabled ? { domain: '.hexschool.com', path: '/' } : {});

export function getCookie(name) {
  return Cookies.get(name);
}

/**
 * 寫入 cookie。
 * @param {string} name - cookie 名稱
 * @param {string} value - cookie 值（原始字串，不做編碼）
 * @param {{ expires?: Date|number, crossSite?: boolean }} [options]
 *   expires 到期時間（Date 或天數，省略則為 session cookie）；
 *   crossSite 是否綁定 .hexschool.com 全站（省略則依 VUE_APP_ENV 判斷）
 */
export function setCookie(name, value, { expires, crossSite = isCrossSiteEnv() } = {}) {
  Cookies.set(name, value, {
    ...(expires ? { expires } : {}),
    ...crossSiteOptions(crossSite),
  });
}

/**
 * 移除 cookie。domain / path 需與寫入時相同才能正確刪除，故沿用同一套跨網域判斷。
 * @param {string} name - cookie 名稱
 * @param {{ crossSite?: boolean }} [options] - crossSite 省略則依 VUE_APP_ENV 判斷
 */
export function removeCookie(name, { crossSite = isCrossSiteEnv() } = {}) {
  Cookies.remove(name, crossSiteOptions(crossSite));
}
